module.exports = __webpack_public_path__ + "static/src/content/images/processed/800/16_9.2eebde9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/800/16_9.jpg
// module id = 9CJ8
// module chunks = 1